import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Team from "@/components/Team";

const About = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <div className="pt-16">
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="text-4xl font-bold text-center text-gray-900 mb-8">
              À Propos de Beauty Hair
            </h1>
            <div className="prose prose-pink mx-auto">
              <p className="text-lg text-gray-600 mb-6">
                Bienvenue chez Beauty Hair, votre destination beauté à Paris. Depuis notre ouverture,
                nous nous efforçons d'offrir à nos clientes une expérience unique et personnalisée
                dans un cadre élégant et accueillant.
              </p>
              <p className="text-lg text-gray-600 mb-6">
                Notre équipe de professionnelles passionnées s'engage à vous offrir les dernières
                tendances en matière de coiffure tout en respectant la santé de vos cheveux.
              </p>
            </div>
          </div>
        </section>
        <Team />
      </div>
      <Footer />
    </div>
  );
};

export default About;